const FNAME = 'results.txt';
const MIME_TYPE = 'text/plain;charset=utf-8';

function exportFile($q, Blob, FileSaver) {
  return (text, fname = FNAME, mimeType = MIME_TYPE) => {
    return $q( (resolve, reject) => {
      try {
        const data = new Blob([text], {type: mimeType});
        FileSaver.saveAs(data, fname);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  };

}

exportFile.$inject = ['$q', 'Blob', 'FileSaver'];
export default exportFile;
